// src/graphql/queries/subscriptionQueries.js

export const getSubscriptions = () => `query GetSubscriptions($tier: SubscriptionTier, $status: SubscriptionStatus, $limit: Int, $offset: Int) {
    adminSubscriptions(tier: $tier, status: $status, limit: $limit, offset: $offset) {
        id
        companyId
        tier
        status
        billingCycle
        price
        priceWithDiscount
        startDate
        endDate
        trialEnd
        canceledAt
        lastBillingDate
        nextBillingDate
        paymentMethod
        createdAt
        updatedAt
        company {
            id
            name
            size
            industry
            maxUsers
            users {
                id
            }
        }
        modules {
            id
            type
            price
            startDate
            endDate
        }
        discounts {
            id
            code
            type
            value
            description
            validFrom
            validUntil
        }
    }
}`;

export const getSubscriptionByCompany = () => `query GetSubscriptionByCompany($companyId: String!) {
    subscriptionByCompany(companyId: $companyId) {
        id
        companyId
        tier
        status
        billingCycle
        price
        priceWithDiscount
        startDate
        endDate
        trialEnd
        canceledAt
        lastBillingDate
        nextBillingDate
        paymentMethod
        createdAt
        updatedAt
        company {
            id
            name
        }
        modules {
            id
            type
            price
            startDate
            endDate
        }
        discounts {
            id
            code
            type
            value
            description
            validFrom
            validUntil
        }
    }
}`;

export const getModulesBySubscription = () => `query GetModulesBySubscription($subscriptionId: String!) {
    modulesBySubscription(subscriptionId: $subscriptionId) {
        id
        subscriptionId
        type
        price
        startDate
        endDate
        createdAt
        updatedAt
    }
}`;

// Live pricing-tier configuration (public query, also drives the pricing
// page). Handy next to subscriptions to see what each tier currently offers.
export const getPricingTiers = () => `query GetPricingTiers {
    pricingTiers {
        tier
        name
        description
        monthlyPriceCents
        yearlyPriceCents
        currency
        features
        highlighted
        trialDays
        yearlySavingsPercent
        maxUsers
        maxFingerprints
        setupFeeCents
    }
}`;
